/*!
 * accounting.js v0.4.2, copyright 2014 Open Exchange Rates, MIT license, http://openexchangerates.github.io/accounting.js
 */
(function(p,z){function q(a){return!!(""===a||a&&a.charCodeAt&&a.substr)}function m(a){return u?u(a):"[object Array]"===v.call(a)}function r(a){return"[object Object]"===v.call(a)}function s(a,b){var d,a=a||{},b=b||{};for(d in b)b.hasOwnProperty(d)&&null==a[d]&&(a[d]=b[d]);return a}function j(a,b,d){var c=[],e,h;if(!a)return c;if(w&&a.map===w)return a.map(b,d);for(e=0,h=a.length;e<h;e++)c[e]=b.call(d,a[e],e,a);return c}function n(a,b){a=Math.round(Math.abs(a));return isNaN(a)?b:a}function x(a){var b=c.settings.currency.format;"function"===typeof a&&(a=a());return q(a)&&a.match("%v")?{pos:a,neg:a.replace("-","").replace("%v","-%v"),zero:a}:!a||!a.pos||!a.pos.match("%v")?!q(b)?b:c.settings.currency.format={pos:b,neg:b.replace("%v","-%v"),zero:b}:a}var c={version:"0.4.1",settings:{currency:{symbol:"$",format:"%s%v",decimal:".",thousand:",",precision:2,grouping:3},number:{precision:0,grouping:3,thousand:",",decimal:"."}}},w=Array.prototype.map,u=Array.isArray,v=Object.prototype.toString,o=c.unformat=c.parse=function(a,b){if(m(a))return j(a,function(a){return o(a,b)});a=a||0;if("number"===typeof a)return a;var b=b||".",c=RegExp("[^0-9-"+b+"]",["g"]),c=parseFloat((""+a).replace(/\((.*)\)/,"-$1").replace(c,"").replace(b,"."));return!isNaN(c)?c:0},y=c.toFixed=function(a,b){var b=n(b,c.settings.number.precision),d=Math.pow(10,b);return(Math.round(c.unformat(a)*d)/d).toFixed(b)},t=c.formatNumber=c.format=function(a,b,d,i){if(m(a))return j(a,function(a){return t(a,b,d,i)});var a=o(a),e=s(r(b)?b:{precision:b,thousand:d,decimal:i},c.settings.number),h=n(e.precision),f=0>a?"-":"",g=parseInt(y(Math.abs(a||0),h),10)+"",l=3<g.length?g.length%3:0;return f+(l?g.substr(0,l)+e.thousand:"")+g.substr(l).replace(/(\d{3})(?=\d)/g,"$1"+e.thousand)+(h?e.decimal+y(Math.abs(a),h).split(".")[1]:"")},A=c.formatMoney=function(a,b,d,i,e,h){if(m(a))return j(a,function(a){return A(a,b,d,i,e,h)});var a=o(a),f=s(r(b)?b:{symbol:b,precision:d,thousand:i,decimal:e,format:h},c.settings.currency),g=x(f.format);return(0<a?g.pos:0>a?g.neg:g.zero).replace("%s",f.symbol).replace("%v",t(Math.abs(a),n(f.precision),f.thousand,f.decimal))};c.formatColumn=function(a,b,d,i,e,h){if(!a)return[];var f=s(r(b)?b:{symbol:b,precision:d,thousand:i,decimal:e,format:h},c.settings.currency),g=x(f.format),l=g.pos.indexOf("%s")<g.pos.indexOf("%v")?!0:!1,k=0,a=j(a,function(a){if(m(a))return c.formatColumn(a,f);a=o(a);a=(0<a?g.pos:0>a?g.neg:g.zero).replace("%s",f.symbol).replace("%v",t(Math.abs(a),n(f.precision),f.thousand,f.decimal));if(a.length>k)k=a.length;return a});return j(a,function(a){return q(a)&&a.length<k?l?a.replace(f.symbol,f.symbol+Array(k-a.length+1).join(" ")):Array(k-a.length+1).join(" ")+a:a})};if("undefined"!==typeof exports){if("undefined"!==typeof module&&module.exports)exports=module.exports=c;exports.accounting=c}else"function"===typeof define&&define.amd?define([],function(){return c}):(c.noConflict=function(a){return function(){p.accounting=a;c.noConflict=z;return c}}(p.accounting),p.accounting=c)})(this);

var splitit_payments = 4;

var is_bot = /bot|googlebot|crawler|spider|robot|crawling/i.test(navigator.userAgent);

function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

function slugify(text) {
  return text.toString().toLowerCase()
    .replace(/\s+/g, '-')           // Replace spaces with -
    .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
    .replace(/\-\-+/g, '-')         // Replace multiple - with single -
    .replace(/^-+/, '')             // Trim - from start of text
    .replace(/-+$/, '');            // Trim - from end of text
}

function createPressReleaseGallery() {
  var img_src;
  var img_src_full;
  var img_src_thumb;
  var images = '';
  $('body.article .post-content table img').each(function(){
    img_src = $(this).prop('src');
    img_src = img_src.replace(/\?v=\d+$/, ''); // remove version number
    img_src_full = img_src.replace(/_[a-z]+\.jpg$/, '.jpg'); // remove image size
    img_src_full = img_src_full.replace(/_[a-z]+\.JPG$/, '.JPG'); // remove image size
    img_src_thumb = img_src.replace(/_[a-z]+\.jpg$/, '_419x279_crop_center.jpg'); // remove image size
    img_src_thumb = img_src_thumb.replace(/_[a-z]+\.JPG$/, '_419x279_crop_center.JPG'); // remove image size
//     console.log({img_src});
//     console.log({img_src_thumb});
    images += '<figure><img src="' + img_src_thumb + '"><a href="https://shopify-api.amalgamcollection.com/download.php?image=' + img_src_full.replace('https://cdn.shopify.com/', '') + '"><span> <svg class="icon icon--download" xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><g><rect fill="none" height="24" width="24"/></g><g><path d="M18,15v3H6v-3H4v3c0,1.1,0.9,2,2,2h12c1.1,0,2-0.9,2-2v-3H18z M17,11l-1.41-1.41L13,12.17V4h-2v8.17L8.41,9.59L7,11l5,5 L17,11z"/></g></svg> Download</span></a></figure>';
    $(this).remove();
  });
  if (images.length > 0) {
    $('<div class="press-gallery">' + images + '</div>').insertAfter('body.article .post-content .post-image');
  	$('body.article .post-content table').remove();
  }
}

$(document).ready(function() {

  function SplititPrice(){
  // Get prices for each instance of a product on page
  $('.product-price').each(function(){
    var price = this.innerText;
    var priceNum = Number(price.replace(/[^0-9.-]+/g,""));   
    var priceFormatted = priceNum*100;
    var price2 = Shopify.formatMoney(price);
    var priceFinal;
    
    if (price2.includes("€")){
       if (priceNum >= 100){        
      var priceFinal = priceNum*1;  
         console.log("over 100 " + priceFinal)
       } else if (priceNum <= 100) {
         var priceFinal = priceNum*100000;
           console.log("below 100 " + priceFinal)
       }
    } else {
      var priceFinal = priceNum*100;
    }

      if ($(this).prop('id') == 'product-price') {
        var splitPrice = Shopify.formatMoney(priceFinal / splitit_payments);
        if (splitPrice == "<span class=money>£0.00</span>"){
          $('#splitit-price').html('POA');
        } else {   
        $('#splitit-price').html(splitPrice);
        }
      } else {
      $(this).html('POA').removeClass('hidden-price');
      if ($(this).prop('id') == 'product-price') {
        $('#splitit-price').html('POA');
      }
    }

  });
}
  SplititPrice();
$( "#variant-selector" ).change(function() {
  SplititPrice();
});

  createPressReleaseGallery();
  
  if ($('#product-form').length > 0 && $('input#user-currency').length > 0) {
    updateVariant(); 
  }
  
  // crude product tabs
  $('.product-tabs .tab').on('click', function() {
    var tab = $(this).data('tab');
    $('.product-tabs .tab').removeClass('selected');
    $(this).addClass('selected');
    $('.product-tabs .tab-panel').hide();
    $('.product-tabs .tab-panel.' + tab).show();
  });
  
 
  // jquery form validation and submission
  $('form.ajax-form').each(function(){
    $(this).validate({
  		submitHandler: function(form) {
              // set langify body class
              if (typeof(langify) !== undefined) {
                $('input[name="language"]').val(langify.helper.getSelectedLanguage());
              }
  			$('div.form-submit-result').text('');
  			$(form).ajaxSubmit({
  // 				target: 'div.form-submit-result',
  				resetForm: true,
  				success: function(responseText, statusText, xhr, $form) {
  					if (statusText == 'success') {
  						$('form.ajax-form input[type="text"], form.ajax-form input[type="email"]').val('');
                        $('div.form-submit-result').text('Thank you - a member of our Sales Team will contact you soon.')
  					} else {
  						alert("There was a problem submitting the form");
  					}					
  				}
  			});
  		}
  	});
  });

  // open magnific popup for youtube videos
  $(document).ready(function() {
    $('.youtube-popup').magnificPopup({
      type: 'iframe',
      iframe: {
        markup: '<div class="mfp-iframe-scaler">'+
                  '<div class="mfp-close"></div>'+
                  '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>'+
                '</div>', // HTML markup of popup, `mfp-close` will be replaced by the close button
      
        patterns: {
          youtube: {
            index: 'youtube.com/', // String that detects type of video (in this case YouTube). Simply via url.indexOf(index).
      
            id: 'v=', // String that splits URL in a two parts, second part should be %id%
            // Or null - full URL will be returned
            // Or a function that should return %id%, for example:
            // id: function(url) { return 'parsed id'; }
      
            src: '//www.youtube.com/embed/%id%?autoplay=1' // URL that will be set as a source for iframe.
          }      
        },
        srcAction: 'iframe_src', // Templating object key. First part defines CSS selector, second attribute. "iframe_src" means: find "iframe" and set attribute "src".
      }
    });
  });
    
  // open magnific popup contact form for out of stock or bespoke items
  $(document).on('click', '#add-to-cart.contact', function() {
    if (typeof($(this).attr('data-contact-type')) == 'undefined') {
      var src = '#contact-form-general';
    } else {
      var src = '#contact-form-' + $(this).attr('data-contact-type');
    }
    $.magnificPopup.open({
      items: {
        src: src,
        type: 'inline'
      }
    });
    return false;
  });
  

  
  // bootstrap tooltips
  $('[data-toggle="tooltip"]').tooltip({ html: true }); 

  // basic accordion
  var allPanels = $('.js-accordionContainer .js-accordionContent').hide();
  $('.js-accordionContainer .js-accordionTitle').click(function() {
    allPanels.slideUp();
    if ($(this).hasClass('accordionTitle--active')) {
      // close everything
      $('.js-accordionContainer .js-accordionTitle').removeClass('accordionTitle--active');
      $(this).next('.js-accordionContent').slideUp();
    } else {
      $('.js-accordionContainer .js-accordionTitle').removeClass('accordionTitle--active');
      $(this).addClass('accordionTitle--active');
      $(this).next('.js-accordionContent').slideDown();
    }
    return false;
  });
  
  if (langify.locale.iso_code != 'en') {
    $('#mfp-splitit').load(`/${langify.locale.iso_code}/pages/splitit #main-content`);
  } else {
    $('#mfp-splitit').load('/pages/splitit #main-content');
  }
  
  // magnific popup inline type
  $('.mfp-inline, a[href="#mfp-splitit"]').magnificPopup({
    type: 'inline'
  });
  
  // add contact details tab for Japan
  $('body.country-JP').append('<div class="contact-details-tab"><button class="toggle"><i class="fa fa-angle-down fa-2x"></i></button><h2>Contact us</h2><div class="padding"><div><strong>Kiyotaka Tamamushi</strong></div><div><a href="mailto:kiyotaka.tamamushi@amalgam.com">kiyotaka.tamamushi@amalgam.com</a></div><div><a href="tel:0081344058309">+81-3-4405-8309</a></div></div></div>');
  $('body.ly55348 .contact-details-tab h2').text('コンタクト ');
  if ($.cookie('contact-details-minimised')) {
    $('.contact-details-tab').addClass('minimised');
  }
  $('.contact-details-tab button.toggle').click(function(){
    $('.contact-details-tab').toggleClass('minimised');
    if ($('.contact-details-tab').hasClass('minimised')) {
      $.cookie('contact-details-minimised', 1, { expires: 365, path: '/' });
      console.log('adding cookie');
    } else{
      $.removeCookie('contact-details-minimised', { path: '/' });
      console.log('removing cookie');
    }
  });
  
  // move archive filter to bottom of status group
  setTimeout(function(){
// 	$('.bc-sf-filter-option-block-status ul').append($('.bc-sf-filter-option-block-status a[href*="pf_pt_status=Archive"]').parent('li'));
//    $('.bc-sf-filter-option-block-status ul').append($('.bc-sf-filter-option-block-status a[href$="=pf"] .bc-sf-filter-option-value').text('Available Now'));
  }, 1000);
  
});

/* photoswipe */

var initPhotoSwipeFromDOM = function(gallerySelector) {

    // parse slide data (url, title, size ...) from DOM elements 
    // (children of gallerySelector)
    var parseThumbnailElements = function(el) {
        var thumbElements = el.childNodes,
            numNodes = thumbElements.length,
            items = [],
            figureEl,
            linkEl,
            size,
            item;

        for(var i = 0; i < numNodes; i++) {

            figureEl = thumbElements[i]; // <figure> element

            // include only element nodes 
            if(figureEl.nodeType !== 1) {
                continue;
            }

            linkEl = figureEl.children[0]; // <a> element

            size = linkEl.getAttribute('data-size').split('x');

            // create slide object
            item = {
                src: linkEl.getAttribute('href'),
                w: parseInt(size[0], 10),
                h: parseInt(size[1], 10)
            };



            if(figureEl.children.length > 1) {
                // <figcaption> content
                item.title = figureEl.children[1].innerHTML; 
            }

            if(linkEl.children.length > 0) {
                // <img> thumbnail element, retrieving thumbnail url
                item.msrc = linkEl.children[0].getAttribute('src');
            } 

            item.el = figureEl; // save link to element for getThumbBoundsFn
            items.push(item);
        }

        return items;
    };

    // find nearest parent element
    var closest = function closest(el, fn) {
        return el && ( fn(el) ? el : closest(el.parentNode, fn) );
    };

    // triggers when user clicks on thumbnail
    var onThumbnailsClick = function(e) {
        e = e || window.event;
        e.preventDefault ? e.preventDefault() : e.returnValue = false;

        var eTarget = e.target || e.srcElement;

        // find root element of slide
        var clickedListItem = closest(eTarget, function(el) {
            return (el.tagName && el.tagName.toUpperCase() === 'FIGURE');
        });

        if(!clickedListItem) {
            return;
        }

        // find index of clicked item by looping through all child nodes
        // alternatively, you may define index via data- attribute
        var clickedGallery = clickedListItem.parentNode,
            childNodes = clickedListItem.parentNode.childNodes,
            numChildNodes = childNodes.length,
            nodeIndex = 0,
            index;

        for (var i = 0; i < numChildNodes; i++) {
            if(childNodes[i].nodeType !== 1) { 
                continue; 
            }

            if(childNodes[i] === clickedListItem) {
                index = nodeIndex;
                break;
            }
            nodeIndex++;
        }

        if(index >= 0) {
            // open PhotoSwipe if valid index found
            openPhotoSwipe( index, clickedGallery );
        }
        return false;
    };

    // parse picture index and gallery index from URL (#&pid=1&gid=2)
    var photoswipeParseHash = function() {
        var hash = window.location.hash.substring(1),
        params = {};

        if(hash.length < 5) {
            return params;
        }

        var vars = hash.split('&');
        for (var i = 0; i < vars.length; i++) {
            if(!vars[i]) {
                continue;
            }
            var pair = vars[i].split('=');
            if(pair.length < 2) {
                continue;
            }           
            params[pair[0]] = pair[1];
        }

        if(params.gid) {
            params.gid = parseInt(params.gid, 10);
        }

        return params;
    };

    var openPhotoSwipe = function(index, galleryElement, disableAnimation, fromURL) {
        var pswpElement = document.querySelectorAll('.pswp')[0],
            gallery,
            options,
            items;

        items = parseThumbnailElements(galleryElement);

        // define options (if needed)
        options = {

            // define gallery index (for URL)
            galleryUID: galleryElement.getAttribute('data-pswp-uid'),

            getThumbBoundsFn: function(index) {
                // See Options -> getThumbBoundsFn section of documentation for more info
                var thumbnail = items[index].el.getElementsByTagName('img')[0], // find thumbnail
                    pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
                    rect = thumbnail.getBoundingClientRect(); 

                return {x:rect.left, y:rect.top + pageYScroll, w:rect.width};
            }

        };

        // PhotoSwipe opened from URL
        if(fromURL) {
            if(options.galleryPIDs) {
                // parse real index when custom PIDs are used 
                // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
                for(var j = 0; j < items.length; j++) {
                    if(items[j].pid == index) {
                        options.index = j;
                        break;
                    }
                }
            } else {
                // in URL indexes start from 1
                options.index = parseInt(index, 10) - 1;
            }
        } else {
            options.index = parseInt(index, 10);
        }

        // exit if index not found
        if( isNaN(options.index) ) {
            return;
        }

        if(disableAnimation) {
            options.showAnimationDuration = 0;
        }

        // Pass data to PhotoSwipe and initialize it
        gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options);
        gallery.init();
    };

    // loop through all gallery elements and bind events
    var galleryElements = document.querySelectorAll( gallerySelector );

    for(var i = 0, l = galleryElements.length; i < l; i++) {
        galleryElements[i].setAttribute('data-pswp-uid', i+1);
        galleryElements[i].onclick = onThumbnailsClick;
    }

    // Parse URL and open gallery if it contains #&pid=3&gid=1
    var hashData = photoswipeParseHash();
    if(hashData.pid && hashData.gid) {
        openPhotoSwipe( hashData.pid ,  galleryElements[ hashData.gid - 1 ], true, true );
    }
};

// execute above function on bespoke gallery pages
let bespokeGalleries = document.querySelectorAll('.bespoke-gallery');

bespokeGalleries.forEach(function (gallery) {
  let galleryID = '#' + gallery.id;
  initPhotoSwipeFromDOM(galleryID);
})

